import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { initTheme } from './stores/theme'
import './styles/theme.css'

// Applied before React mounts. Doing it in an effect instead means dark-mode
// users get a white flash on every page load.
initTheme()

// Mark this browser as an app user. Catalogue URLs (business and product
// pages) are server-rendered for crawlers and JavaScript-less readers; with
// this cookie present they serve the app instead, so a refresh gives back the
// page the visitor was actually on. A cookie rather than a user-agent test:
// the same request always gets the same answer, whoever sends it.
try {
  const secure = location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `naijaindex.view=app; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax${secure}`
} catch {
  /* cookies disabled: catalogue pages still work, just styled as documents */
}

const container = document.getElementById('root')
if (!container) throw new Error('No #root element in the document.')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
